import React from "react";

export const PhoneFrame = ({ src, alt, className = "", testId }) => {
  return (
    <div
      data-testid={testId}
      className={`relative mx-auto aspect-[9/19] w-full max-w-[280px] rounded-[2.4rem] border border-[hsl(var(--border))] bg-[hsl(var(--ink))] p-2 shadow-[0_30px_80px_-30px_rgba(26,37,30,0.45)] ${className}`}
    >
      <div className="absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-full bg-[hsl(var(--ink))]" />
      <div className="relative h-full w-full overflow-hidden rounded-[1.9rem] bg-[hsl(var(--surface-secondary))]">
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="h-full w-full object-cover object-top"
        />
      </div>
    </div>
  );
};

export default PhoneFrame;
